import React from 'react'

const IconAdvancedSearch = ({ style = {}, ...props }) => {
  return (
    <svg
      width="30"
      height="30"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}>
      <g fill="#77CA34" fillRule="evenodd">
        <circle fillOpacity=".07" cx="15" cy="15" r="15" />
        <path
          d="M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zm0 25C9.477 25 5 20.523 5 15S9.477 5 15 5s10 4.477 10 10a10 10 0 0 1-10 10zm0-17a7 7 0 0 0-7 7 1.5 1.5 0 0 0 3 0 4 4 0 0 1 4-4 1.5 1.5 0 0 0 0-3z"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}

export default IconAdvancedSearch
